module.exports = __webpack_public_path__ + "media/night/365-782f8b30.svg";